<mat-card appearance="outlined" class="mat-elevation-z1 mat-card-scrollable">
    <mat-card-header>
        <mat-card-title>{{ title | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        @if (favoritesList.length > 0) {
            <table mat-table [dataSource]="favoritesList">
                <ng-container matColumnDef="tableName">
                    <th mat-header-cell *matHeaderCellDef>{{ 'Favorites.Resource' | translate }}</th>
                    <td mat-cell *matCellDef="let item">
                        <i class="material-icons" [ngClass]="item.tableName"></i>
                    </td>
                </ng-container>
                <ng-container matColumnDef="label">
                    <th mat-header-cell *matHeaderCellDef>{{ 'General.Description' | translate }}</th>
                    <td mat-cell *matCellDef="let item">{{ item.label }}</td>
                </ng-container>
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let item">
                        <button mat-icon-button (click)="remove($event, item)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row (click)="goToView(row)" *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
        } @else {
            {{ 'Favorites.NoFavorites' | translate }}
        }
    </mat-card-content>
</mat-card>
